import { ReporteEncuestaService } from "./../../../administrador/reportes/encuesta/reporte-encuesta.service";
import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { Subscription, Observable, of } from "rxjs";
import { CompletaInformacionService } from "./completa-informacion.service";
import { CategoriaEntry } from "src/app/shared/entrys/categoria.entry";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SubCategoriaEntry } from "src/app/shared/entrys/sub-categoria.entry";
import { EstablecimientoComercioService } from "../../establecimiento-comercio/establecimiento-comercio.service";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { PrestadorEntry } from "src/app/shared/entrys/prestador.entry";
import { RatificaInformacionEntry } from "src/app/shared/entrys/ratificacion-informacion.entry";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";
import { DialogConfirmacionService } from "src/app/shared/services/dialog-confirmacion.service";
import { map } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalCambioInmuebleComponent } from "src/app/components/core/layouts/modal-cambio-inmueble/modal-cambio-inmueble.component";
// tslint:disable-next-line:max-line-length
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
  TipoConfirmacionModalType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { ModalAceptarTerminosComponent } from "src/app/components/core/layouts/modal-aceptar-terminos/modal-aceptar-terminos.component";
import { UsuarioProvisionalModel } from "src/app/shared/models/usuario-provisional.model";

import { ModalCategoriaEstablecimientoComponent } from "./../../../../../layouts/modal-categoria-establecimiento/modal-categoria-establecimiento/modal-categoria-establecimiento.component";

import { DetalleDocumentosService } from "./../../../funcionario/opciones/documentos/documentos.service";
import { BaseServiceService } from "src/app/shared/services/base-service.service";
import { ActividadEconomicaEntry } from "src/app/shared/entrys/actividad-economica.entry";
import { ModalActividadEconomicaComponent } from "src/app/components/seguridad/layouts/modal-actividad-economica/modal-actividad-economica.component";
import { DetalleEstablecimientoService } from "../../../funcionario/opciones/establecimiento/establecimiento.service";

import { CategoriaService } from "../../../administrador/configuracion/categoria/categoria.service";
import { ModalValidarRenovacionComponent } from "src/app/components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component";
import { SubcategoriaService } from "../../../administrador/configuracion/subcategoria/subcategoria.service";
import { ModalValidarSubcategoriaComponent } from "src/app/components/core/layouts/modal-validar-subcategoria/modal-validar-subcategoria.component";
import { ModalNuevaCategoriaComponent } from "src/app/components/core/layouts/modal-nueva-categoria/modal-nueva-categoria.component";
import { C, I } from "@angular/cdk/keycodes";
import { EstadosRnt } from '../../../../../../../shared/enumeraciones/estados-rnt.enum';
import { TipoCapacidad } from "src/app/shared/enumeraciones/tipo-capacidad.enum";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { CapacidadTecnicaService } from '../capacidad/capacidad-tecnica.service';
import { CapacidadOperativaService } from '../capacidad/capacidad-operativa.service';

@Component({
  selector: "app-completa-informacion",
  templateUrl: "./completa-informacion.component.html",
  styleUrls: ["./completa-informacion.component.scss"],
})
export class CompletaInformacionComponent implements OnInit, OnDestroy {
  @Output() pasoActual: EventEmitter<any> = new EventEmitter();
  hasRequiredActions: boolean = false;
  auxCategoriaEs: string;
  auxCategoria: number;
  boolCactegoriaux: boolean = false;
  subscription: Subscription;
  establecimiento: EstablecimientoEntry;
  prestador: PrestadorEntry;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  categorias: Array<CategoriaEntry>;
  subCategorias: Array<SubCategoriaEntry>;
  completaForm: FormGroup;
  tipo_renovacion = TipoSolicitud.Renovacion;
  tipo_reactivacion = TipoSolicitud.Reactivacion;
  tipo_edicion = TipoSolicitud.Actualizacion;
  estado_devuelto = EstadosSolicitud.Devuelto;
  estado_suspendido_por_no_renovar = EstadosRnt.SuspendidoPorNoRenovar;
  rnt: RNTPrestadorEntry;
  ratificaInformacion: RatificaInformacionEntry;
  texto_aceptacion_terminos: string = "";
  texto_descripcion_decreto343: string = "";
  titulo_decreto_343: string = "";
  informacionUsuarioDepositario: UsuarioProvisionalModel;
  nombrePrestador: string;
  showContainerMatrMerc: boolean = false;
  categoriaActual: any = null;
  establecimientoDetalle: any;
  subCategoriasDisabled: boolean = false;
  mostrarCapacidadTecnica: boolean = false;
  mostrarCapacidadOperativa: boolean = false;

  constructor(
    private router: Router,
    private dataSharedService: DataSharedService,
    private dialogConfirmacionService: DialogConfirmacionService,
    private completaInformacionService: CompletaInformacionService,
    private formBuilder: FormBuilder,
    private establecimientoComercioService: EstablecimientoComercioService,
    private modalService: NgbModal,
    private authService: AuthService,
    private baseService: BaseServiceService,
    public ayudaService: AyudasService,
    public docService: DetalleDocumentosService,
    public RepoService: ReporteEncuestaService,
    private detalleEstablecimientoService: DetalleEstablecimientoService,
    private subCategoriaService: SubcategoriaService,
    private categoriaService: CategoriaService,
    private capacidadTecnicaService: CapacidadTecnicaService,
    private capacidadOperativaService: CapacidadOperativaService,
  ) {
    this.prestador = {} as PrestadorEntry;
    this.rnt = {} as RNTPrestadorEntry;
    this.establecimiento = {} as EstablecimientoEntry;
    this.subscription = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
      this.auxCategoria = this.datoSolicitudSharedModel.data.categoria_id;
      
      if (
        this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Renovacion 
        || 
        (
          this.datoSolicitudSharedModel.data.estado_rnt_id ===
          EstadosRnt.SuspendidoPorNoRenovar &&  
          this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Reactivacion
        ) 
        || this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Actualizacion
      ) {
        this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;

        this.completaInformacionService
            .getEstablecimientosPendiente({...this.rnt/*detalle_solicitud_id:'1212'*/})
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimientoDetalle = resultado.data as EstablecimientoEntry;
                this.formulario();
                this.comprobarTipoPermisoCategoria();
              }
            },error=>{
              this.formulario();
            });

        this.ratificaInformacion = {
          cantidad_modificaciones:
            this.datoSolicitudSharedModel.data.cantidad_modificaciones || 0,
          ratifica_informacion:
            this.datoSolicitudSharedModel.data.ratifica_informacion || false,
        } as RatificaInformacionEntry;

        this.formulario();
      } else {
        if (
          this.datoSolicitudSharedModel.estado_solicitud ===
          EstadosSolicitud.Devuelto
        ) {
          this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
          this.formulario();
        } else {
          if (this.datoSolicitudSharedModel.data.detalle_solicitud_id) {
            this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
          } else {
            this.establecimiento = this.datoSolicitudSharedModel
              .data as EstablecimientoEntry;
          }
          this.formulario();
        }
      }
    });
    this.comprobarTipoPermisoCategoria();
  }
  comprobarTipoPermisoCategoria(): void{
    this.completaInformacionService
        .getCategoriaPermissionsById(this.auxCategoria ?? Number(this.rnt.categoria_id))
        .subscribe(response=>{
            if(response.codigoRespuesta == 0){
              if(this.establecimientoDetalle == null){
                this.establecimientoDetalle={tipo_permiso_categoria:response.data[0].tipo_permiso};
              }
            }
            this.deshabilitaSubcategoria();
        },error=>{
          this.deshabilitaSubcategoria();
        });
  }
  ngOnInit() {
    this.auxCategoriaEs = "";
    this.pasoActual.emit(1);

    if(this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion){
        this.pasoActual.emit(2);
    }


    this.getConfiguracionCapacidadTecnica();
    this.getConfiguracionCapacidadOperativa();
    this.establecimientoComercioService
      .getPrestador({
        usuario: this.authService.getUserNameToken(),
        ...this.datoSolicitudSharedModel.data,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.informacionUsuarioDepositario =
            resultado.data.numero_identificacion_usuario_provisional !== null
              ? {
                  cargo_usuario_provisional:
                    resultado.data.cargo_usuario_provisional,
                  correo_electronico_reportado:
                    resultado.data.correo_electronico_reportado,
                  correo_usuario_provisional:
                    resultado.data.correo_usuario_provisional,
                  nombre_usuario_provisional:
                    resultado.data.nombre_usuario_provisional,
                  apellido_usuario_provisional:
                    resultado.data.apellido_usuario_provisional,
                  numero_identificacion_usuario_provisional:
                    resultado.data.numero_identificacion_usuario_provisional,
                  tipo_identificacion_usuario_provisional:
                    resultado.data.tipo_identificacion_usuario_provisional,
                }
              : null;
          this.prestador = resultado.data as PrestadorEntry;

          if (this.prestador.tipo_prestador_id === 1) {
            this.showContainerMatrMerc = true;
          }

          this.cargaInicial();
        }
      });
  }

  cargaInicial() {
    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      this.establecimientoComercioService
        .getEstablecimiento(this.rnt)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.establecimiento = resultado.data as EstablecimientoEntry;

            localStorage.setItem("keyCamaraID", this.establecimiento.codigo_camara);
            localStorage.setItem("keyMatricula", this.establecimiento.matricula);
            if (
              this.datoSolicitudSharedModel.estado_solicitud ===
              EstadosSolicitud.Devuelto
            ) {
              if (
                this.datoSolicitudSharedModel.data &&
                this.datoSolicitudSharedModel.data.detalle_solicitud_id
              ) {
                if (
                  this.rnt.aplica_pago_parafiscales &&
                  this.rnt.aplica_pago_parafiscales === true && (
                  (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
                    this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
                  this.datoSolicitudSharedModel.tipo_solicitud ===
                      TipoSolicitud.Renovacion ) &&
                  !this.datoSolicitudSharedModel.data
                    .excepcion_municipio_pago_fontur
                ) {
                  this.pasoActual.emit({ totalPasos: 7 });
                }
                this.formulario();
                this.onCategoria();
                this.completaForm.patchValue(
                  {
                    sub_categoria_id: this.rnt.sub_categoria_id,
                  },
                  { emitEvent: false, onlySelf: true }
                );
              } else {
                this.completaInformacionService
                  .createDevolucion(this.rnt)
                  .subscribe((resultadoDev) => {
                    if (resultadoDev.result) {
                      this.rnt = { ...this.rnt, ...resultadoDev.data };
                      if (
                        this.rnt.aplica_pago_parafiscales &&
                        this.rnt.aplica_pago_parafiscales === true &&
                        ((this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
                          this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
                        this.datoSolicitudSharedModel.tipo_solicitud ===
                            TipoSolicitud.Renovacion ) &&
                        !this.datoSolicitudSharedModel.data
                          .excepcion_municipio_pago_fontur
                      ) {
                        this.pasoActual.emit({ totalPasos: 7 });
                      }
                      this.formulario();
                      this.onCategoria();
                      this.completaForm.patchValue(
                        {
                          sub_categoria_id: this.rnt.sub_categoria_id,
                        },
                        { emitEvent: false, onlySelf: true }
                      );
                    } else {
                      this.router.navigate(["/mis-establecimientos"]);
                    }
                  });
              }
            } else {
              if (
                this.datoSolicitudSharedModel.tipo_solicitud ===
                TipoSolicitud.Actualizacion
              ) {
                if (
                  this.datoSolicitudSharedModel.data &&
                  this.datoSolicitudSharedModel.data.detalle_solicitud_id
                ) {
                  this.formulario();
                  this.onCategoria();
                  this.completaForm.patchValue(
                    {
                      sub_categoria_id: this.rnt.sub_categoria_id,
                    },
                    { emitEvent: false, onlySelf: true }
                  );
                } else {
                  this.completaInformacionService
                    .createActualizacion(this.rnt)
                    .subscribe((resultadoRen) => {
                      if (resultadoRen.result) {
                        this.rnt = { ...this.rnt, ...resultadoRen.data };
                        this.formulario();
                        this.onCategoria();
                        this.completaForm.patchValue(
                          {
                            sub_categoria_id: this.rnt.sub_categoria_id,
                          },
                          { emitEvent: false, onlySelf: true }
                        );
                      } else {
                        this.router.navigate(["/mis-establecimientos"]);
                      }
                    });
                }
              } else {
                if (
                  this.datoSolicitudSharedModel.data &&
                  this.datoSolicitudSharedModel.data.detalle_solicitud_id
                ) {
                  if (
                    this.rnt.aplica_pago_parafiscales &&
                    this.rnt.aplica_pago_parafiscales === true &&
                    !this.datoSolicitudSharedModel.data
                      .excepcion_municipio_pago_fontur
                  ) {
                    this.pasoActual.emit({ totalPasos: 6 });
                  }

                  /// validacion decreto 343
                  if (
                    this.auxCategoria === 4 &&
                    ((this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
                      this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
                  this.datoSolicitudSharedModel.tipo_solicitud ===
                      TipoSolicitud.Renovacion )
                  ) {
                    this.boolCactegoriaux = true;
                    this.showModalDecreto343();
                  }

                  this.formulario();
                } else {
                  this.completaInformacionService
                    .createRenovacion(this.rnt)
                    .subscribe((resultadoEdicion) => {
                      if (resultadoEdicion.result) {
                        this.rnt = { ...this.rnt, ...resultadoEdicion.data };
                        if (
                          this.rnt.aplica_pago_parafiscales &&
                          this.rnt.aplica_pago_parafiscales === true &&
                          !this.datoSolicitudSharedModel.data
                            .excepcion_municipio_pago_fontur
                        ) {
                          this.pasoActual.emit({ totalPasos: 6 });
                        }
                        this.formulario();
                      } else {
                        this.router.navigate(["/mis-establecimientos"]);
                      }
                    });
                }
              }
            }
            this.validacionElegirNuevaCategoria();
          }
        });
    } else {
      if (
        this.datoSolicitudSharedModel.estado_solicitud ===
        EstadosSolicitud.Devuelto
      ) {
        if (
          this.datoSolicitudSharedModel.data &&
          this.datoSolicitudSharedModel.data.detalle_solicitud_id
        ) {
          this.establecimientoComercioService
            .getEstablecimiento(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;

                localStorage.setItem("keyCamaraID", this.establecimiento.codigo_camara);
                localStorage.setItem("keyMatricula", this.establecimiento.matricula);

                this.formulario();
                this.completaInformacionService
                  .get({
                    ...this.establecimiento,
                    rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
                    tipo_rnt_id:
                      this.rnt.tipo_rnt_id || this.establecimiento.tipo_rnt_id,
                    prestador_id: this.prestador.prestador_id,
                  })
                  .subscribe((resultadoCate) => {
                    if (resultadoCate.result) {
                      this.categorias =
                        resultadoCate.data as Array<CategoriaEntry>;
                    }
                  });
                if (
                  this.datoSolicitudSharedModel.tipo_solicitud ===
                  TipoSolicitud.Actualizacion
                ) {
                  this.onCategoria();
                  this.completaForm.patchValue(
                    {
                      sub_categoria_id: this.rnt.sub_categoria_id,
                    },
                    { emitEvent: false, onlySelf: true }
                  );
                }
              }
            });
        } else {
          this.establecimientoComercioService
            .getEstablecimiento(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;

                localStorage.setItem("keyCamaraID", this.establecimiento.codigo_camara);
                localStorage.setItem("keyMatricula", this.establecimiento.matricula);
                
                if (
                  this.datoSolicitudSharedModel.data &&
                  this.datoSolicitudSharedModel.data.detalle_solicitud_id
                ) {
                  this.formulario();
                  if (
                    this.datoSolicitudSharedModel.tipo_solicitud ===
                    TipoSolicitud.Actualizacion
                  ) {
                    this.onCategoria();
                    this.completaForm.patchValue(
                      {
                        sub_categoria_id: this.rnt.sub_categoria_id,
                      },
                      { emitEvent: false, onlySelf: true }
                    );
                  }
                } else {
                  this.completaInformacionService
                    .createDevolucion(this.rnt)
                    .subscribe((resultadoDev) => {
                      if (resultadoDev.result) {
                        this.rnt = { ...this.rnt, ...resultadoDev.data };
                        this.formulario();
                        if (
                          this.datoSolicitudSharedModel.tipo_solicitud ===
                          TipoSolicitud.Actualizacion
                        ) {
                          this.onCategoria();
                          this.completaForm.patchValue(
                            {
                              sub_categoria_id: this.rnt.sub_categoria_id,
                            },
                            { emitEvent: false, onlySelf: true }
                          );
                        }
                      } else {
                        this.router.navigate(["/mis-establecimientos"]);
                      }
                    });
                }
              }
            });
        }
      } else {
        if (
          this.datoSolicitudSharedModel.data &&
          this.datoSolicitudSharedModel.data.detalle_solicitud_id
        ) {
          this.establecimientoComercioService
            .getEstablecimiento(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;

                localStorage.setItem("keyCamaraID", this.establecimiento.codigo_camara);
                localStorage.setItem("keyMatricula", this.establecimiento.matricula);

                this.formulario();
                this.completaInformacionService
                  .get({
                    ...this.establecimiento,
                    rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
                    tipo_rnt_id:
                      this.rnt.tipo_rnt_id || this.establecimiento.tipo_rnt_id,
                    prestador_id: this.prestador.prestador_id,
                  })
                  .subscribe((resultadoCate) => {
                    if (resultadoCate.result) {
                      this.categorias =
                        resultadoCate.data as Array<CategoriaEntry>;
                    }
                  });
                this.onCategoria();
                this.completaForm.patchValue({
                  sub_categoria_id: this.rnt.sub_categoria_id,
                });
              }
            });
        } else {
          this.completaInformacionService
            .get({
              ...this.establecimiento,
              rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
              tipo_rnt_id:
                this.rnt.tipo_rnt_id || this.establecimiento.tipo_rnt_id,
              prestador_id: this.prestador.prestador_id,
            })
            .subscribe((resultadoCate) => {
              if (resultadoCate.result) {
                this.categorias = resultadoCate.data as Array<CategoriaEntry>;
              }
            });
        }
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubCategoria(): void {
    this.validarSubCategoria();
    this.getConfiguracionCapacidadTecnica();
    this.getConfiguracionCapacidadOperativa();
  }

  validarSubCategoria(): void {
    if (
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ||
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)
    ) {
      this.validarSubCategoriaCIIU();
    }
  }

  validarSubCategoriaCIIU(): void {
    let prestador_id: number = this.prestador.prestador_id;
    let sub_categoria_id: number =
      this.completaForm.getRawValue().sub_categoria_id ??
      this.rnt.sub_categoria_id;
    let tipo_rnt_id : number = this.rnt.tipo_rnt_id;
    if (prestador_id != null && sub_categoria_id != null && tipo_rnt_id != null) {
      this.subscription.add(
        this.subCategoriaService
          .validarActividadesEconomicasCiiu(prestador_id, sub_categoria_id,tipo_rnt_id)
          .subscribe(
            (response) => {
              if (!response.data) {
                this.completaInformacionService
                  .getParametro({
                    parametro_id:
                      "ADVERTENCIA_ACTIVIDAD_ECONOMICA_NO_CORRESPONDE_SUBCATEGORIA_PRESTADOR",
                    agrupacion: "VALIDACIONES",
                    auxiliar: "1",
                  })
                  .subscribe(
                    (resultado2) => {
                      if (resultado2.result) {
                        const modalAceptarTerminos = this.modalService.open(
                          ModalValidarSubcategoriaComponent,
                          { centered: true, backdrop: "static", size: "md" }
                        );
                        modalAceptarTerminos.componentInstance.mensaje =
                          resultado2.data;
                      }
                    }
                  );
              }
            }
          )
      );
    }
  }

  goPaso() {
    if(this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion){
        this.rnt.paso = 2;
    }
    this.completaInformacionService
      .getParametro({
        parametro_id: "INDICADOR_MOSTRAR_TRATAMIENTO_DATOS_SOLICITUD",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          if (resultado.data) {
            if(
              this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
              this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion
            ){
              this.validarRenovacionSegunTipoSolicitud();    
            }else{
              this.showModalAceptarTermino();
            }
            
          } else {
            this.continuarPaso();
          }
        } else {
          this.router.navigate(["/mis-establecimientos"]);
        }
      });
  }

  private onAlertaSeleccionarNuevaCategoria(
    hayNuevasCategorias: boolean,
    esObligatorio: boolean,
    categoria: any
  ): any {
    if (!hayNuevasCategorias) {
      return;
    }
    const modal = this.modalService.open(ModalNuevaCategoriaComponent, {
      centered: true,
      backdrop: "static",
      size: "lg",
      keyboard: false,
    });
    modal.componentInstance.titulo = categoria.titulo_mensaje_permitir_cambio_categoria;
    modal.componentInstance.mensaje = categoria.mensaje_permitir_cambio_categoria;
    modal.componentInstance.esObligatorio = esObligatorio;
    modal.componentInstance.categoriaData = this.rnt.categoria_id;
    modal.result.then((res: any) => {
            
            if (res.nueva_categoria_id && res.subcategoria_id) {
              this.hasRequiredActions = false;
              this.completaForm.controls.categoria_id.setValue(
                res.nueva_categoria_id
              );
              this.completaForm.controls.desc_categoria.enable();
              this.completaForm.controls.desc_categoria.setValue(
                res.desc_nueva_categoria
              );
              this.completaForm.controls.desc_categoria.disable();
              const subcategorias: SubCategoriaEntry = {
                sub_categoria_id: res.subcategoria_id,
                descripcion: res.desc_subcategoria,
                activo: true,
                orden: 0,
                usuario_auditoria: "",
              };
              this.subCategorias = [subcategorias];
              this.completaForm.controls.sub_categoria_id.setValue(
                res.subcategoria_id
              );
              this.completaForm.controls.sub_categoria_id.disable();
            
            }
      });
  }

  private validacionElegirNuevaCategoria(): any {
    this.categoriaService
      .getByIdUser(this.rnt.categoria_id)
      .subscribe((x: any) => {
        const categoria = x.data[0];
        let esObligatorioActualizacion = categoria.obligatorio_actualizacion;
        let esObligatorioRenovacion = categoria.obligatorio_renovacion;
        let permiteCambio = categoria.permite_cambio_categoria;
        if( this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Actualizacion && permiteCambio){
          this.openModalCambioDeCategoriaObligatoria(categoria,esObligatorioActualizacion);
        }
        if( (this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Renovacion || 
            this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Reactivacion) && permiteCambio ){
          this.openModalCambioDeCategoriaObligatoria(categoria,esObligatorioRenovacion);
        }
      });
  }
  
  private openModalCambioDeCategoriaObligatoria(categoria: any,esObligatorio : boolean): void{
    if (
      categoria.permite_cambio_categoria &&
      categoria.fecha_fin_cambio_categoria &&
      categoria.fecha_inicio_cambio_categoria
    ) {
      const today = new Date();
      const fechaFin = new Date(categoria.fecha_fin_cambio_categoria);
      const fechaInicio = new Date(categoria.fecha_inicio_cambio_categoria);
      const fechaHoyRango = new Date(today.getFullYear(), today.getMonth(), today. getDate());
      const fechasEnRango: boolean =
      fechaHoyRango <= fechaFin && fechaHoyRango >= fechaInicio;
      const hayNuevasCategorias: boolean =
        categoria.ids_categorias !== "" ||
        categoria.ids_categorias !== null ||
        categoria.ids_categorias !== undefined;
      
      if (fechasEnRango) {
        this.hasRequiredActions = esObligatorio;;
        return this.onAlertaSeleccionarNuevaCategoria(
          hayNuevasCategorias,
          esObligatorio,
          categoria
        );
      }
    }
  }
  private realizarCambiosCategoriaSubcategoria(): any {
    if (
      this.completaForm.controls.categoria_id.value == this.rnt.categoria_id &&
      this.completaForm.controls.sub_categoria_id.value ==
        this.rnt.sub_categoria_id
    ) {
      return;
    }

    const request: any = {
      categoria_id          : this.completaForm.controls.categoria_id.value,
      sub_categoria_id      : this.completaForm.controls.sub_categoria_id.value,
      rnt_id                : this.rnt.rnt_id,
      detalle_solicitud_id  : this.rnt.detalle_solicitud_id
    };

    this.completaInformacionService
      .cambiarCategoriaSubcategoria(request)
      .subscribe((x: any) => {
        if (
          x.data[0]?.categoria_id &&
          x.data[0]?.sub_categoria_id &&
          this.rnt.rnt_id == x.data[0]?.rnt_id
        ) {
          this.rnt.categoria_id = x.data[0].categoria_id;
          this.rnt.sub_categoria_id = x.data[0].sub_categoria_id;
        }
      });
  }

  continuarPaso() {
    if (
      (
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion || 
        (
          this.datoSolicitudSharedModel.data.estado_rnt_id ===
          EstadosRnt.SuspendidoPorNoRenovar &&  
          this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Reactivacion
        )
      ) &&
      this.rnt.permite_cambio_tipo_rnt
    ) {
      this.abrirModalCambioRNT();
    } else {
      if (
        this.auxCategoria === 4 &&
        (this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Renovacion ||
          (
            this.datoSolicitudSharedModel.data.estado_rnt_id ===
            EstadosRnt.SuspendidoPorNoRenovar &&  
            this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Reactivacion
          ) )
      ) {
        this.ActualizarRegistrosDoc();
      }

      this.preGoPaso();
    }
  }

  preGoPaso() {
    if (
      (
        this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion
      ) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      this.realizarCambiosCategoriaSubcategoria();
      const rnt: RNTPrestadorEntry = {
        ...this.rnt,
        tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud
      };
      
      if (
        this.rnt.sub_categoria_id === this.completaForm.getRawValue().sub_categoria_id
      ) {
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: {
            ...rnt,
            ratificaInformacion: this.ratificaInformacion,
            nit: this.prestador.nit,
            tipo_prestador_id: this.prestador.tipo_prestador_id,
            sub_categoria_id: this.completaForm.get("sub_categoria_id").value,
            categoria_id: this.completaForm.value.categoria_id,
          } as RNTPrestadorEntry,
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
          this.router.navigate(['/solicitud/capacidad']);
        } else{
          this.router.navigate([
            "/solicitud/tipo-establecimiento",
          ]);
        }
      } else {
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: {
            ...rnt,
            ratificaInformacion: this.ratificaInformacion,
            nit: this.prestador.nit,
            tipo_prestador_id: this.prestador.tipo_prestador_id,
            sub_categoria_id: this.completaForm.get("sub_categoria_id").value,
            categoria_id: this.completaForm.value.categoria_id,
          } as RNTPrestadorEntry,
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        const modalRef = this.modalService.open(
          ModalConfirmarRespuestaComponent,
          { centered: true }
        );
        
        const confirmarRespuesta = {} as ConfirmarRespuestaModel;
        confirmarRespuesta.tipoConfirmacionModalType =
          TipoConfirmacionModalType.Confirmacion;
        confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
        // tslint:disable-next-line:max-line-length
        confirmarRespuesta.message =
          "¿Está seguro de cambiar la subcategoria del registro? Esta acción eliminará la información registrada hasta el momento.";
        modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
        modalRef.result
                  .then((resultadoModal) => {
                    this.completaInformacionService
                      .cambiarCategoria({
                        ...this.rnt,
                        sub_categoria_id: this.completaForm.getRawValue().sub_categoria_id,
                      })
                      .subscribe((resultado) => {
                        if (resultado.result) {
                          let rnt: RNTPrestadorEntry = {
                            ...this.rnt,
                            tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
                            sub_categoria_id: this.completaForm.getRawValue().sub_categoria_id
                          };
                          
                          this.dataSharedService.sharedData(<
                            DatoSolicitudSharedModel
                          >{
                            data: {
                              ...rnt,
                              ...resultado.data,
                              ratificaInformacion: this.ratificaInformacion,
                              nit: this.prestador.nit,
                              sub_categoria_id: this.completaForm.value.sub_categoria_id,
                              categoria_id: this.completaForm.value.categoria_id,
                              tipo_prestador_id: this.prestador.tipo_prestador_id
                            } as RNTPrestadorEntry,
                            tipo_solicitud:
                              this.datoSolicitudSharedModel.tipo_solicitud,
                            tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                            estado_solicitud:
                              this.datoSolicitudSharedModel.estado_solicitud,
                            
                          });
                          if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                            this.router.navigate(['/solicitud/capacidad']);
                          } else{
                            this.router.navigate([
                              "/solicitud/tipo-establecimiento",
                            ]);
                          }
                        }
                      });
                  })
                  .catch(() => {
                    this.completaForm.patchValue({
                      categoria_id: this.rnt.categoria_id,
                      sub_categoria_id: this.completaForm.getRawValue().sub_categoria_id
                    });
                  });
      }
      
      
    } else {
      if (
        this.datoSolicitudSharedModel.estado_solicitud ===
        EstadosSolicitud.Devuelto
      ) {
        const rnt: RNTPrestadorEntry = {
          ...this.rnt,
          tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
        };
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: {
            ...rnt,
            tipo_prestador_id: this.prestador.tipo_prestador_id,
          } as RNTPrestadorEntry,
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          categoria_id: this.completaForm.value.categoria_id,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
          this.router.navigate(['/solicitud/capacidad']);
        } else{
          this.router.navigate([
            "/solicitud/tipo-establecimiento",
          ]);
        }
      } else {
        const rnt: RNTPrestadorEntry = {
          ...this.rnt,
          ...this.establecimiento,
          ...this.completaForm.value,
          tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
        };
        if (!this.rnt.sub_categoria_id) {
          this.crearRNT(rnt);
        } else {
          if (
            this.rnt.sub_categoria_id === this.completaForm.getRawValue().sub_categoria_id ||
            this.rnt.es_devuelta
          ) {
            this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
              data: {
                ...rnt,
                tipo_prestador_id: this.prestador.tipo_prestador_id,
              } as RNTPrestadorEntry,
              tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
              categoria_id: this.completaForm.value.categoria_id,
              tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
              estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
            });
            if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
              this.router.navigate(['/solicitud/capacidad']);
            } else{
              this.router.navigate([
                "/solicitud/tipo-establecimiento",
              ]);
            }
          } else {
            const modalRef = this.modalService.open(
              ModalConfirmarRespuestaComponent,
              { centered: true }
            );
            const confirmarRespuesta = {} as ConfirmarRespuestaModel;
            confirmarRespuesta.tipoConfirmacionModalType =
              TipoConfirmacionModalType.Confirmacion;
            confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
            // tslint:disable-next-line:max-line-length
            confirmarRespuesta.message =
              "¿Está seguro de cambiar la categoria del registro? Esta acción eliminará la información registrada hasta el momento.";
            modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
            modalRef.result
              .then((resultadoModal) => {
                this.completaInformacionService
                  .revertir(this.rnt)
                  .subscribe((resultado) => {
                    if (resultado.result) {
                      this.crearRNT(rnt);
                    }
                  });
              })
              .catch(() => {
                this.completaForm.patchValue(
                  {
                    categoria_id: this.rnt.categoria_id,
                    sub_categoria_id: this.completaForm.value.sub_categoria_id,
                  },
                  { emitEvent: false, onlySelf: true }
                );
                if (this.rnt.categoria_id) {
                  this.completaInformacionService
                    .getSubCategoria({
                      ...this.datoSolicitudSharedModel.data,
                      tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                      categoria_id: this.rnt.categoria_id,
                      tipo_solicitud_id:
                        this.datoSolicitudSharedModel.tipo_solicitud,
                    })
                    .subscribe((result) => {
                      if (result.result) {
                        this.subCategorias =
                          result.data as Array<SubCategoriaEntry>;
                      }
                    });
                } else {
                  this.subCategorias = [];
                }
              });
          }
        }
      }
    }
  }

  private crearRNT(rnt: RNTPrestadorEntry) {
    this.completaInformacionService.create(rnt).subscribe((resultado) => {
      if (resultado.result) {
        const categoriaSelect = this.categorias.find(
          (busqueda) =>
            busqueda.categoria_id === this.completaForm.value.categoria_id
        );
        rnt = { ...rnt, descripcion_categoria: categoriaSelect.descripcion };
        // sessionStorage.setItem('rnt', JSON.stringify(resultado.data as RNTPrestadorEntry));
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: {
            ...rnt,
            ...resultado.data,
            categoria_id: this.completaForm.value.categoria_id,
            tipo_prestador_id: this.prestador.tipo_prestador_id,
          } as RNTPrestadorEntry,
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
        });
        if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
          this.router.navigate(['/solicitud/capacidad']);
        } else{
          this.router.navigate([
            "/solicitud/tipo-establecimiento",
          ]);
        }
      }
    });
  }

  onCategoria() {
    localStorage.setItem("idCategoria", this.completaForm.value.categoria_id);

    // tslint:disable-next-line:max-line-length
    this.completaForm.patchValue({
      categoria_id: this.completaForm.value.categoria_id,
      sub_categoria_id: (this.completaForm.value.sub_categoria_id == null )?null:this.completaForm.value.sub_categoria_id,
    }); // TODO: Validar si este cambio no afecto a la pantalla
    if (this.completaForm.value.categoria_id) {
      this.auxCategoriaEs = this.completaForm.value.categoria_id;
      // this.grabar_localStorage();
      //consultar sub categoria
      this.completaInformacionService
        .getSubCategoria({
          ...this.datoSolicitudSharedModel.data,
          tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
          categoria_id: this.completaForm.value.categoria_id,
          tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            if (
              ((this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
                this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
              this.datoSolicitudSharedModel.tipo_solicitud ===
                TipoSolicitud.Renovacion) &&
              this.auxCategoria === 4
            ) {
              //Extraer las nuevas subcategoria en caso de aplicar decreto 343
              this.RepoService.getSubCategoriaxCategoria(
                this.completaForm.value.categoria_id
              ).subscribe((resultado) => {
                if (resultado.result) {
                  this.subCategorias.splice(0, this.subCategorias.length);
                  var auxSubcat = resultado.data as Array<SubCategoriaEntry>;
                  this.subCategorias = auxSubcat;
                }
              });
            } else {
              this.subCategorias = resultado.data as Array<SubCategoriaEntry>;
            }
          }
        });
    } else {
      this.subCategorias = [];
    }
  }

  formulario() {
    if (
      (
        this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion
      ) ||
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion
    ) {
      if (this.auxCategoria === 4) {
        this.formularioAux();
        this.onCategoria();
        this.completaForm.patchValue(
          {
            sub_categoria_id: null,
          },
          { emitEvent: false, onlySelf: true }
        );
      } else {
        this.completaForm = this.formBuilder.group({
          detalle_solicitud_id: [
            this.rnt.detalle_solicitud_id,
            Validators.required,
          ],
          //Aqui voy
          desc_categoria: [
            { value: this.rnt.descripcion_categoria, disabled: true },
            Validators.required,
          ],
          desc_sub_categoria: [
            {
              value: this.rnt.descripcion_tipo_establecimiento,
              disabled: true,
            },
            Validators.required,
          ],categoria_id: [
            this.completaForm && this.completaForm.value.categoria_id
              ? this.completaForm.value.categoria_id
              : this.rnt.categoria_id,
            Validators.required,
          ],
          sub_categoria_id: [
            this.completaForm && this.completaForm.value.sub_categoria_id
              ? this.completaForm.value.sub_categoria_id
              : this.rnt.sub_categoria_id,
            Validators.required,
          ],
        });
        this.onCategoria();
        this.completaForm.patchValue({
            sub_categoria_id: this.rnt.sub_categoria_id,
        },{emitEvent: false, onlySelf: true});
      }
    } else if (
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Actualizacion
    ) {
      this.completaForm = this.formBuilder.group({
        detalle_solicitud_id: [
          this.rnt.detalle_solicitud_id,
          Validators.required,
        ],
        desc_categoria: [
          { value: this.rnt.descripcion_categoria, disabled: true },
          Validators.required,
        ],
        categoria_id: [
          this.completaForm && this.completaForm.value.categoria_id
            ? this.completaForm.value.categoria_id
            : this.rnt.categoria_id,
          Validators.required,
        ],
        sub_categoria_id: [
          this.completaForm && this.completaForm.value.sub_categoria_id
            ? this.completaForm.value.sub_categoria_id
            : this.rnt.sub_categoria_id,
          Validators.required,
        ],
      });
    } else {
      if (
        this.datoSolicitudSharedModel.estado_solicitud ===
          EstadosSolicitud.Devuelto ||
        this.rnt.es_devuelta
      ) {
        this.completaForm = this.formBuilder.group({
          detalle_solicitud_id: [
            this.rnt.detalle_solicitud_id,
            Validators.required,
          ],
          desc_categoria: [
            { value: this.rnt.descripcion_categoria, disabled: true },
            Validators.required,
          ],
          desc_sub_categoria: [
            {
              value: this.rnt.descripcion_tipo_establecimiento,
              disabled: true,
            },
            Validators.required,
          ],
        });
      } else {
        this.completaForm = this.formBuilder.group({
          categoria_id: [
            this.completaForm && this.completaForm.value.categoria_id
              ? this.completaForm.value.categoria_id
              : this.rnt.categoria_id,
            Validators.required,
          ],
          sub_categoria_id: [
            this.completaForm && this.completaForm.value.sub_categoria_id
              ? this.completaForm.value.sub_categoria_id
              : this.rnt.sub_categoria_id,
            Validators.required,
          ],
        });
      }
    }
    this.validarSubCategoria();
  }

  formularioAux() {
    this.completaForm = this.formBuilder.group({
      detalle_solicitud_id: [
        this.rnt.detalle_solicitud_id,
        Validators.required,
      ],
      desc_categoria: [
        { value: this.rnt.descripcion_categoria, disabled: true },
        Validators.required,
      ],
      categoria_id: [
        this.completaForm && this.completaForm.value.categoria_id
          ? this.completaForm.value.categoria_id
          : this.rnt.categoria_id,
        Validators.required,
      ],
      sub_categoria_id: [
        this.completaForm && this.completaForm.value.sub_categoria_id
          ? this.completaForm.value.sub_categoria_id
          : this.rnt.sub_categoria_id,
        Validators.required,
      ],
    });
    this.validarSubCategoria();
  }

  abrirModalCambioRNT() {
    const modalRef = this.modalService.open(ModalCambioInmuebleComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    // tslint:disable-next-line:max-line-length
    confirmarRespuesta.message =
      '¿Desea cambiar el tipo de RNT a "Inmueble"? Importante: Si realiza el cambio debe dirigirse a la cámara de comercio para cancelar el registro mercantil.';
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result
      .then(() => {
        this.rnt.tipo_rnt_id = TipoRnt.Inmuebles;
        this.completaInformacionService
          .cambiarInmueble({
            ...this.rnt,
          })
          .subscribe((resultado) => {
            if (resultado.result) {
              this.datoSolicitudSharedModel.tipo_rnt = TipoRnt.Inmuebles;
              const rnt: RNTPrestadorEntry = {
                ...this.rnt,
                tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
              };
              this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                data: {
                  ...rnt,
                  ratificaInformacion: this.ratificaInformacion,
                  nit: this.prestador.nit,
                  categoria_id: this.completaForm.value.categoria_id,
                  tipo_prestador_id: this.prestador.tipo_prestador_id,
                } as RNTPrestadorEntry,
                tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
                tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                estado_solicitud:
                  this.datoSolicitudSharedModel.estado_solicitud,
              });
              this.router.navigate([
                "/solicitud/completa-informacion-inmueble",
              ]);
            }
          });
      })
      .catch(() => this.preGoPaso());
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.rnt.paso && this.rnt.paso !== 1) {
      return this.dialogConfirmacionService.confirmar().pipe(
        map((data) => {
          if (data) {
            // this.router.navigate([this.menuService.getRoles()[0].ruta_url]);
          }
          return data;
        })
      );
    } else {
      return of(true);
    }
  }

  showModalAceptarTermino() {
    this.completaInformacionService
      .getParametro({
        parametro_id: "TEXTO_TRATAMIENTO_DATOS_PASO_SOLICITUD",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.texto_aceptacion_terminos = resultado.data;
          this.completaInformacionService
            .getParametro({
              parametro_id: "TITULO_MODAL_TRATAMIENTO_DATOS_SOLICITUD",
              agrupacion: "TRATAMIENTO_DATOS",
              auxiliar: "1",
            })
            .subscribe((resultado2) => {
              if (resultado2.result) {
                const modalAceptarTerminos = this.modalService.open(
                  ModalAceptarTerminosComponent,
                  { centered: true, backdrop: "static", size: "lg" }
                );
                modalAceptarTerminos.componentInstance.mensaje =
                  this.texto_aceptacion_terminos;
                modalAceptarTerminos.componentInstance.titulo = resultado2.data;
                modalAceptarTerminos.result.then(() => {
                  this.validarRenovacionSegunTipoSolicitud();
                });
              }
            });
        }
      });
  }

  grabar_localStorage() {
    var codCategoria =
      this.auxCategoriaEs !== "" ? this.auxCategoriaEs : this.rnt.categoria_id;
    localStorage.setItem("keyCategoria", codCategoria);
  }


  showModalDecreto343() {
    this.completaInformacionService
      .getParametro({
        parametro_id: "TEXTO_DECRETO_343",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.texto_descripcion_decreto343 =
            resultado.data !== ""
              ? resultado.data
              : "Agregrar Descripcion desde el modulo parametro";
          this.completaInformacionService
            .getParametro({
              parametro_id: "TITULO_MODAL_DECRETO_343",
              agrupacion: "TRATAMIENTO_DATOS",
              auxiliar: "1",
            })
            .subscribe((resultado2) => {
              if (resultado2.result) {
                this.titulo_decreto_343 =
                  resultado2.data !== ""
                    ? resultado2.data
                    : "Agregar Titulo descripcion desde el modulo parametro";
                const modalCategoriaEsta = this.modalService.open(
                  ModalCategoriaEstablecimientoComponent,
                  { centered: true, backdrop: "static", size: "lg" }
                );
                modalCategoriaEsta.componentInstance.mensaje =
                  this.texto_descripcion_decreto343;
                modalCategoriaEsta.componentInstance.titulo =
                  this.titulo_decreto_343;
                modalCategoriaEsta.componentInstance.rnt = this.rnt;
                modalCategoriaEsta.result.then(() => {
                  this.filtarArrayCategoria();
                });
              }
            });
        }
      });
  }

  filtarArrayCategoria() {
    this.completaInformacionService
      .get({
        ...this.establecimiento,
        rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
        tipo_rnt_id: this.rnt.tipo_rnt_id || this.establecimiento.tipo_rnt_id,
        prestador_id: this.prestador.prestador_id,
      })
      .subscribe((resultadoCate) => {
        if (resultadoCate.result) {
          this.categorias = resultadoCate.data as Array<CategoriaEntry>;
        }

        this.categorias = this.categorias.filter(function (e) {
          return e.categoria_id === 20 || e.categoria_id === 21;
        });

        this.subCategorias = [];
      });

    this.completaForm.controls["categoria_id"].setValue(null, {
      onlySelf: true,
    });
  }

  ActualizarRegistrosDoc() {
    this.docService
      .ActualizarDoc343({
        Rnt_Id: this.rnt.rnt_id,
        Codigo_Camara: this.rnt.codigo_camara,
        Solicitud_Id: this.rnt.solicitud_id,
        Detalle_Solicitud_Id: this.rnt.detalle_solicitud_id,
        Categoria_Id: this.completaForm.get("categoria_id").value,
        Sub_Categoria_Id: this.completaForm.get("sub_categoria_id").value,
      })
      .subscribe((response) => {
        if (response.result) {
          this.rnt.categoria_id = response.data.categoria_id;
          this.rnt.sub_categoria_id = response.data.sub_categoria_id;

          const categoriaSel = this.categorias.find(
            (busqueda) => busqueda.categoria_id === response.data.categoria_id
          );

          this.rnt.descripcion_categoria = categoriaSel.descripcion;

          const Subcategoria = this.subCategorias.find(
            (busqueda) =>
              busqueda.sub_categoria_id === response.data.sub_categoria_id
          );

          this.rnt.descripcion_tipo_establecimiento = Subcategoria.descripcion;

          this.auxCategoria = response.data.categoria_id;

          this.formulario();
        }
      });
  }

  verActividades(tipo: string) {
    if (tipo === "establecimiento") {
      let numero_identificacion = this.prestador.nit;
      let digito_verificacion = this.prestador.digito_verificacion.toString();
      let codigo_camara = this.datoSolicitudSharedModel.data.codigo_camara;
      let numero_matricula = this.datoSolicitudSharedModel.data.matricula;

      this.baseService
        .getActividadesEconomicasEstablecimientos(
          numero_identificacion,
          digito_verificacion,
          codigo_camara,
          numero_matricula
        )
        .subscribe((response) => {
          if (response.control.code == 200) {
            const actividadesEconomicas =
              response.data as Array<ActividadEconomicaEntry>;
            const modalRef = this.modalService.open(
              ModalActividadEconomicaComponent,
              {
                centered: true,
                size: "lg",
                backdropClass: "light-blue-backdrop",
              }
            );
            modalRef.componentInstance.actividadesEconomicas =
              actividadesEconomicas;
            modalRef.componentInstance.tipoUsuario =
              this.authService.getTipoUser();
          }
        });
    } else if (tipo === "prestador") {
      this.nombrePrestador = this.authService.getUserNameToken();

      this.baseService
        .getActividadesEconomicasPrestador(this.nombrePrestador)
        .subscribe((response) => {
          if (response.control.code == 200) {
            const actividadesEconomicas =
              response.data as Array<ActividadEconomicaEntry>;
            const modalRef = this.modalService.open(
              ModalActividadEconomicaComponent,
              {
                centered: true,
                size: "lg",
                backdropClass: "light-blue-backdrop",
              }
            );
            modalRef.componentInstance.actividadesEconomicas =
              actividadesEconomicas;
            modalRef.componentInstance.tipoUsuario =
              this.authService.getTipoUser();
          }
        });
    }
  }

 
  deshabilitaSubcategoria(){

    if (this.datoSolicitudSharedModel.tipo_solicitud == 7 ) {
      switch(this.establecimientoDetalle?.tipo_permiso_categoria) {
        case "0": {
           this.completaForm.controls.sub_categoria_id.disable();
           break;
        }
        case "1": {
          this.completaForm.controls.sub_categoria_id.enable();
          break;
        }
        case "2": {
          this.completaForm.controls.sub_categoria_id.disable();
          break;
        }
        case "3": {
          this.completaForm.controls.sub_categoria_id.enable();
          break;
        }
        default: {
          break;
        }
      }
    }

    if (this.datoSolicitudSharedModel.tipo_solicitud == 2 || 
        this.datoSolicitudSharedModel.tipo_solicitud == 5) {
      switch (this.establecimientoDetalle?.tipo_permiso_categoria) {
        case "0": {
          this.completaForm.controls.sub_categoria_id.disable();
          break;
        }
        case "1": {
          this.completaForm.controls.sub_categoria_id.disable();
          break;
        }
        case "2": {
          this.completaForm.controls.sub_categoria_id.enable();
          break;
        }
        case "3": {
          this.completaForm.controls.sub_categoria_id.enable();
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  validarRenovacionSegunTipoSolicitud(): void {
    if (
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.tipo_solicitud === 
        TipoSolicitud.Renovacion ||
      (
          this.datoSolicitudSharedModel.data.estado_rnt_id ===
          EstadosRnt.SuspendidoPorNoRenovar &&  
          this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Reactivacion
      )

    ) {
      this.validarRenovacion();
    } else {
      this.continuarPaso();
    }
  }
  getParam({parametro_id,agrupacion,auxiliar},hasAction: boolean): void{
    this.establecimientoComercioService
        .getParametro({
          parametro_id,
          agrupacion,
          auxiliar,
        })
          .subscribe(
            (resultado2) => {
              if (resultado2.result) {
                const modalAceptarRenovacion = this.modalService.open(
                  ModalValidarRenovacionComponent,
                  { centered: true, backdrop: "static", size: "md" }
                );
                modalAceptarRenovacion.componentInstance.mensaje =
                  resultado2.data;
              }
              if(hasAction){
                this.continuarPaso();
              }
            },
            (error) => {
              if(hasAction){
                this.continuarPaso();
              }
            }
          );
  }
  validarRenovacion(): void {
    let prestador_id: number = this.prestador.prestador_id;
    let establecimiento_id: number = this.establecimiento.establecimiento_id;

    if (prestador_id != null) {
      this.detalleEstablecimientoService
        .validarRenovacion(establecimiento_id, prestador_id)
        .subscribe(
          (response) => {
            
            if (!response.result) {
              //SI EL ESTABLECIMIENTO ESTA VENCIDO
              if( Number(response.control.code) === 1){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_ESTABLECIMIENTO'
                },true);
              }
              //SI EL PRESTADOR ESTA VENCIDO
              if( Number(response.control.code) === 2){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_PRESTADOR'
                },true);
              }
              //SI EL PRESTADOR Y ESTABLECIMIENTO ESTAN VENCIDOS
              if( Number(response.control.code) === 3){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_PRESTADOR'
                },false);
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_ESTABLECIMIENTO'
                },true);
              }
            } else {
              this.continuarPaso();
            }
          },
          (error) => {
            this.continuarPaso();
          }
        );
    } else {
      this.continuarPaso();
    }
  }

  onRegresarPaso(): void{
    if((
      this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion
    )){
      this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
        data: {
          ...this.rnt,
          ...this.datoSolicitudSharedModel.data,
          ratificaInformacion: this.ratificaInformacion,
          nit: this.datoSolicitudSharedModel.data.nit,
          es_devuelta: true,
        } as RNTPrestadorEntry,
        tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
        tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
        estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
      });
      this.router.navigate(["otra-solicitudes"]);
    }
  }
  getConfiguracionCapacidadTecnica() {
    let idCapacidadTecnica = TipoCapacidad.Tecnica;
    let isComerciante = this.authService.getRolDetalleUser() === TipoPrestador.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica,  this.datoSolicitudSharedModel.data.categoria_id  ?? this.completaForm.value.categoria_id)
      .subscribe((response) => {
        if (response.result) {
          if (response.data[0]) {
            if (isComerciante) {
              this.mostrarCapacidadTecnica = response.data[0].Se_Muestra_Comerciante;
            } else {
              this.mostrarCapacidadTecnica = response.data[0].Se_Muestra_No_Comerciante;
            }
          } else {
            console.log('___WARNING, NO DATA FOUND');
          }
        } else {
          console.log('___ERROR, WEB SERVICE');
        }
      });
  }

  getConfiguracionCapacidadOperativa() {
    let idCapacidadTecnica = TipoCapacidad.Operativa;
    let isComerciante = this.authService.getRolDetalleUser() === TipoPrestador.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica,  this.datoSolicitudSharedModel.data.categoria_id  ?? this.completaForm.value.categoria_id)
      .subscribe((response) => {
        if (response.result) {
          if (response.data[0]) {
            if (isComerciante) {
              this.mostrarCapacidadOperativa = response.data[0].Se_Muestra_Comerciante;
            } else {
              this.mostrarCapacidadOperativa = response.data[0].Se_Muestra_No_Comerciante;
            }
          } else {
            console.log('___WARNING, NO DATA FOUND');
          }
        } else {
          console.log('___ERROR, WEB SERVICE');
        }
      });
  }

  reset_LocalStorage(){
		localStorage.removeItem("keyCamaraID");
		localStorage.removeItem("keyMatricula");
	  }

}

